import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const StyleMenu = styled.div`
    background-color: white;
    border: 2px solid #aaa;
	border-radius: 5px;
    ul,
    li {
        padding: 0;
        margin: 0;
    }
    li {
        padding: 10px;
        list-style-type: none;
		cursor: pointer;
		border-bottom: 2px solid #cdcdcd;
		&:last-child {
			border-bottom: none;
		}
    }
    li:hover {
        background-color: gray;
		color: white;
    }
`

const ContextMenu = ({ position, onOptionSelected, menuOptions }) => {
	const [t] = useTranslation()

	const handleOptionSelected = option => () => onOptionSelected(option)

	const getOffsetRect = (elem) => {
		let box = elem.getBoundingClientRect()

		let body = document.body
		let docElem = document.documentElement

		let scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop
		let scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft

		let clientTop = docElem.clientTop || body.clientTop || 0
		let clientLeft = docElem.clientLeft || body.clientLeft || 0

		let top = box.top + scrollTop - clientTop
		let left = box.left + scrollLeft - clientLeft

		return { top: Math.round(top), left: Math.round(left) }
	}


	const room = document.getElementById('room')
	const coord = getOffsetRect(room)

	return (
		<StyleMenu style={{ position: 'absolute', left: position.x + coord.left, top: position.y + coord.top }}>
			<ul>
				{menuOptions.includes('copy') &&
					<li onClick={handleOptionSelected('copy')}>{t('restaurant_designer_section.fields.dnd_clone')}</li>}
				{menuOptions.includes('delete') &&
					<li onClick={handleOptionSelected('delete')}>{t('restaurant_designer_section.fields.dnd_delete')}</li>}
			</ul>
		</StyleMenu>
	)
}

export default ContextMenu
